import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';

// Google OAuth code flow: this page receives ?code= and trades it for our own session.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleRedirectUri = () => `${window.location.origin}/auth/google`;

export const startGoogleLogin = () => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) { toast.error('Falta configurar el cliente de Google'); return; }
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: googleRedirectUri(),
    response_type: 'code',
    scope: 'openid email profile',
    prompt: 'select_account',
    access_type: 'offline',
    include_granted_scopes: 'true',
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};

const GoogleCallback = () => {
  const navigate = useNavigate();
  const { signInGoogle } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    (async () => {
      if (error || !code) {
        if (error) toast.error('No se completó el acceso con Google');
        navigate('/app/login', { replace: true });
        return;
      }
      try {
        const user = await signInGoogle(code, googleRedirectUri());
        toast.success(`¡Bienvenido, ${(user.name || '').split(' ')[0]}!`);
        navigate('/app/home', { replace: true });
      } catch {
        navigate('/app/login', { replace: true });
      }
    })();
  }, [navigate, signInGoogle]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-[#120b0b] text-white" data-testid="google-callback">
      <Loader2 size={28} className="animate-spin text-[#EE3B36]" />
      <p className="text-sm text-white/70">Validando tu cuenta de Google...</p>
    </div>
  );
};

export default GoogleCallback;
